import axios from "axios";
import FileDownload from "js-file-download";
import { hooksStore } from "../stores/hooks.store.js";

const port = location.port || (location.protocol === "https:" ? "443" : "80");

// Create a instance of axios to use the same base url.
const axiosAPI = axios.create({
  baseURL: `${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}`, // it's not recommended to have this info here.
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// implement a method to execute all the request from here.
const apiRequest = (method, url, request, fileDownload = false) => {
  const headers = {
    authorization: "",
  };
  let options = {
    method,
    url,
    data: request,
    headers,
  };
  // ak chcem subor stahovat, musim poziadat o iny typ odpovede
  if (fileDownload !== false) {
    options.responseType = "blob";
  }
  //using the axios instance to perform the request that received from each http method
  return axiosAPI(options)
    .then((res) => {
      // ak chcem subor stiahnut, tak pouzijem plugin, ktory rovno prehliadacu ponukne subor na stiahnutie
      if (fileDownload !== false) {
        FileDownload(res.data, fileDownload);
      } else {
        return Promise.resolve(res.data);
      }
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          hooksStore.doAction("odhlasitUzivatela");
        }
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      // console.log(error.config);
      return Promise.reject(error);
    });
};

// function to execute the http get request
const get = (url, request, fileDownload) =>
  apiRequest("get", url, request, fileDownload);

// function to execute the http delete request
const deleteRequest = (url, request) => apiRequest("delete", url, request);

// function to execute the http post request
const post = (url, request, fileDownload) =>
  apiRequest("post", url, request, fileDownload);

// function to execute the http put request
const put = (url, request) => apiRequest("put", url, request);

// function to execute the http path request
const patch = (url, request) => apiRequest("patch", url, request);

// expose your method to other services or actions
const API = {
  get,
  delete: deleteRequest,
  post,
  put,
  patch,
};
export default API;
